module.exports = __webpack_public_path__ + "img/card_img_7.2cb5f9df.png";